import React, { ChangeEvent, useCallback, useState, KeyboardEvent, memo, useEffect } from 'react';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import styles from '../chatBot.module.scss';
import { Button } from './Button';
import { AddMessage } from '../../redux/reducers/chatBotReducer';
import { fetchSendMessages } from '../servises';
import { PAMMState } from '../../redux/reducers/rootReducer';

export const Input = memo(() => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const FetchStatus = useSelector((state: PAMMState) => state.chatBotReducer.FetchStatus);
  const [value, setValue] = useState<string>('');
  const [messageToSend, setMessageToSend] = useState<string>('');

  const sendMessage = useCallback(() => {
    if (!messageToSend.length) {
      return;
    }
    dispatch(AddMessage({ text: messageToSend, role: 'user' }));
    setValue('');
    dispatch(fetchSendMessages({ value: escape(messageToSend) }));
  }, [dispatch, messageToSend]);

  const onKeyPress = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && messageToSend.length) {
        sendMessage();
      }
    },
    [sendMessage, messageToSend]
  );

  const onChangeMessage = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, []);

  useEffect(() => {
    setMessageToSend(value);
  }, [value]);

  return (
    <div className={styles['wrapperInput']}>
      <input
        disabled={FetchStatus.loading || FetchStatus.status !== 200}
        onKeyUp={onKeyPress}
        type="text"
        placeholder={`${intl.formatMessage({ id: 'askQuestion' })}...`}
        value={value}
        onChange={onChangeMessage}
        className={`ai-question ${styles['textMsg']}`}
      />
      <Button
        text={intl.formatMessage({ id: 'button.sendMessage' })}
        cb={sendMessage}
        icon={faPaperPlane}
        cls={styles['pushMsg']}
        type="prompt"
        color="var(--black-400)"
      />
    </div>
  );
});
